import React from 'react';
import '../../../styles/mainContents.css'
import { fetchLoc } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import ErrorHandler from '../zzzPracticeTestPages/ErrorHandler';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import BatteryHeader from '../../layout/BatteryHeader';

function Battery(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const {authreducer, fetch_loc, locState, errorHandler, logoutJWT} = props;
  console.log("Battery() authreducer: " + JSON.stringify(authreducer));

  const columns = [
    {
      name: "LOC",
      label: "loc",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "NAME",
      label: "name",
      options: {
        filter: true,
        sort: true,
      },
    },
  ]

  const options = {
    filterType: "checkbox",
  };

  return (

    <div className="BatteryCN">
      {/* <Home /> */}

 
      <main>

        <div>
          <ErrorHandler errorHandler={errorHandler || {hasError: false, message: ''}} />

          <div>


            {console.log('Battery authreducer.isLoggedIn:', authreducer.isLoggedIn)}
            {!authreducer.isLoggedIn ? (

              <React.Fragment>              
                {history.push('/login')}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <BatteryHeader/>

                  {/* <div className="PageTitleDiv">
                    <h1 className="PageTitle">Battery Page</h1>
                    <div className="PageSubMenuDiv">

                        <Link to="/battery/corporate" className="PageSubMenuLink">
                            <h3 className="PageSubMenuHeading">Corporate</h3>
                        </Link>
                                                                                                                
                    </div>
                </div> */}
              </React.Fragment>
            )}

            {/* <button
              onClick={ () => {
                //fetch_loc();
                dispatch(fetchLoc());
              }}
              > Fetch Loc Data
            </button>             */}

            {/* <div>
            
              { locState.length > 0 ?
                  <MUIDataTable
                    title={"Loc Data"}
                    data={locState}
                    columns={columns}
                    options={options}
                  />
                : '' 
              }

            </div> */}



          </div>
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
 return {
  //  locState: state.posts['items_fetchLoc'],
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  console.log("Battery() mapDispatchToProps called ");
  return {
    // fetch_loc: () => {
    //   dispatch(fetchLoc());
    // }//,

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Battery);